"use client";
import { Button, Col, Input, Card, message } from "antd";
import React, { useState } from "react";

enum Quality {
  p720 = "720p1176kbs",
  p360 = "360p878kbs",
}

function ConvertToMp4Card() {
  const [streamKey, setStreamKey] = useState<string>("");
  const [videoUrl, setVideoUrl] = useState<string>("");

  const qualityConvert = async (quality: Quality) => {
    return message.error("Unimplemented", 10);
    if (streamKey && videoUrl) {
      try {
        // const response = await recordApi.post("tasks/convert", {
        //   stream_key: streamKey,
        //   url: videoUrl,
        //   quality: quality,
        // });
        // if (response.status === 200) {
        //   message.success("video converted successfully");
        // } else {
        //   message.error("failed to convert video");
        // }
      } catch (error: any) {
        console.log(error?.response?.data?.error, "error");
        message.error(error?.response?.data?.error, 10);
      }
    } else {
      message.error("please enter both streamkey and url");
    }
  };
  return (
    <div>
      <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className="mb-2">
        <Card title="Convert to mp4">
          <Input
            placeholder="Enter url"
            value={videoUrl}
            onChange={(event) => setVideoUrl(event.target.value)}
            style={{ marginBottom: "1rem" }}
          />
          <Input
            placeholder="Enter stream key"
            value={streamKey}
            onChange={(event) => setStreamKey(event.target.value)}
            style={{ marginBottom: "1rem" }}
          />
          <Button
            onClick={() => qualityConvert(Quality.p360)}
            loading={false}
            type="primary"
            style={{ marginRight: "1rem" }}
          >
            360p
          </Button>
          <Button
            onClick={() => qualityConvert(Quality.p720)}
            loading={false}
            type="primary"
            style={{ marginRight: "1rem" }}
          >
            720p
          </Button>
        </Card>
      </Col>
    </div>
  );
}

export default ConvertToMp4Card;
